import React from 'react';
import { Modal, Form } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
  useModalState,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownReasonChange } from '../../api';
import { ShutdownField } from '../../../common/ui/ShutdownField';
import {
  fieldNames,
  changeModalWithInfoBodyStyle,
} from '../../../common/config';
import NotificationSendingAlert, {
  notificationSendingAlertMsgTypes,
} from '../../../../../shared/ui/NotificationSendingAlert/NotificationSendingAlert';

const ModalContainer = ({ form }) => {
  const { type, initialValues: shutdown = {} } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => dispatch({ type: modalActionTypes.resetModalData });

  const { change, loading } = useShutdownReasonChange();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const data = { value: formValues[fieldNames.reason] };
        await change({ shutdownId: shutdown.alertId, data });
        close();
      }
    });
  };

  return (
    <Modal
      visible={type === modalTypes.changeShutdownReason}
      onCancel={close}
      onOk={handleSubmit}
      title={`${shutdown.alertReason ? 'Изменить' : 'Добавить'} причину`}
      destroyOnClose
      confirmLoading={loading}
      bodyStyle={changeModalWithInfoBodyStyle}
    >
      <NotificationSendingAlert
        messageType={notificationSendingAlertMsgTypes.all}
      />
      <Form colon={false}>
        <ShutdownField
          name={fieldNames.reason}
          form={form}
          initialValue={shutdown.alertReason?.id}
          editMode
        />
      </Form>
    </Modal>
  );
};

const ChangeModal = Form.create({ name: 'change_shutdown_reason' })(
  ModalContainer
);

export default ChangeModal;
